import layout from '@/layout'

export default {
  path: '/pre_close_out',
  component: layout,
  redirect: '/pre_close_out/page6',
  name: 'pre_close_out_page6',
  meta: {
    title: 'pre_close_out',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_out/page6',
      name: 'pre_close_out_page6',
      component: () => import('@/views/pre_settle/pre_close/out/index6'),
      meta: {
        title: 'pre_close_out_page6',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
